import type { FontsType } from '@openeducation/oe-it-themes';
import * as React from 'react';
import type { StyleProp, TextStyle } from 'react-native';
import ReactMarkdown from 'react-native-markdown-display';

import { OEText } from '../../atoms/oe-text/oe-text';
import { TestId } from '../../constants/test-id';

export interface MDTextProps {
  color?: string;
  size?: number;
  children: string;
  fontFamily: FontsType;
  testID?: string;
  style?: StyleProp<TextStyle>;
  renderWithinText?: boolean;
}

// Typing hack until ReactMarkdown updates to React 18, it's declared in every component to avoid reutilization
const _ReactMarkdown: React.FC<any> = ({ children, ...props }) => (
  <ReactMarkdown {...props}>{children}</ReactMarkdown>
);

export const MDText = ({
  fontFamily,
  color,
  children,
  size = 14,
  style,
  testID = TestId.MD_TEXT,
  renderWithinText = true,
}: MDTextProps) => {
  if (!renderWithinText) {
    const markdownStyle = {
      text: [
        style,
        { fontSize: size, color, fontFamily: fontFamily?.regular.fontFamily },
      ],
      textgroup: { color },
    };

    return <_ReactMarkdown style={markdownStyle}>{children}</_ReactMarkdown>;
  }

  return (
    <OEText
      fontFamily={fontFamily}
      color={color}
      fontSize={size}
      style={style}
      testID={testID}
    >
      <_ReactMarkdown>{children}</_ReactMarkdown>
    </OEText>
  );
};

export default MDText;
